import React, {useState, useEffect, useRef} from 'react'
import Moment from 'moment'
import {useHistory} from 'react-router'
import {RouteComponentProps} from 'react-router'
import {
  addVisitanteGlobal,
  generateTokenticket,
  horasIdaAvailable,
  mountPayloadStretch,
  quitarVisitanteGlobal, visOK,
  addExtraGlobal, quitarExtraGlobal, horasIdaAvailableBefore, IMaxBeforeReserve
} from '../Util'
import {CtaView} from "../../components/CtaView"
import {DialogNoDate} from "../../components/DialogNoDate"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import {Carousel} from "react-responsive-carousel"
import CalendarAvailable from "../../components/CalendarAvailable"
import {HeaderView} from '../../components/HeaderView'
import {IHora} from '../../models/IHora'
import {TypeTicket} from '../../models/TypetTicket'
import {addStretchToCart, applyCoupon, getProviderData, getStretch, getStretchA} from './Request'
import {addDiscount, IDiscount, resetDiscount, Vis} from '../../models/Vis'
import Stretch from '../../models/Stretch'
import {ViewApi} from '@fullcalendar/react'
import {InfoWeb} from 'components/InfoWeb'
import {PricesView} from 'components/PricesView'
import {FooterView} from 'components/FooterView'
import {getChannels} from 'Request/Request'
import {modalError, modalInfo} from 'Modules/Payment/Request'
import Spinner from 'reactstrap/es/Spinner'
import * as Sentry from "@sentry/react"
import {Extras} from 'components/Extras'
import {BodyError} from 'components/bodyError'
import {useInitIdioma} from 'customHooks/useInitIdioma'
import {SelectIdaVuelta} from 'components/SelectIdaVuelta'
import {OrigenDestino} from 'components/OrigenDestino'
import queryString from 'query-string'
import {Request} from '../Afiliate/Request'
import {DisabledDay,} from '../../helpers/DisabledDay'
import '../../components/LanguageButtons.css'
import './styles.css'
import {LanguageButtons} from '../../components/LanguageButtons'
import {CodeDiscountView} from '../../components/CodeDiscountView'
import {generateQueryString, getMininimumPassengerREach, initVis} from './Util'
import {getCart} from '../Cart/Request'
import {getNumberItemsCart} from '../Cart/CartPage'
import {addCollaboratorStretchToCart, getCollaboratorStretchData} from '../Collaborator/Request'
import CollaboratorStretch from '../../models/CollaboratorStretch'
import {DataBuyer} from '../BuyerUser/DataBuyer'
import BuyerRequest from '../BuyerUser/Request'
import AgencyHeaderView from '../../components/AgencyHeaderView'
import {VueltaViceversaView} from '../../components/VueltaViceversaView/VueltaViceversaView'
import DataBuyerHeader from '../../components/DataBuyerHeader'

interface TrayectoParams {
  stretch_id?: string
  operator_id?: string
  operatioLine_id?: string
  public?: string
}

type TrayectoProps = RouteComponentProps<TrayectoParams>

interface Props extends TrayectoProps {
  embebed?: boolean
  isCollaborator?: boolean
}

export const StretchPage: React.FC<Props> = (props: Props) => {

  const stretch_id = Number(props.match.params.stretch_id)
  const operator_id = Number(props.match.params.operator_id)
  const publicToken = props.match.params.public
  const embebed = props.embebed

  const history = useHistory()

  const {idioma, t, T, i18n} = useInitIdioma(publicToken) // Custom Hook

  const init: Vis = {
    names: [],
    indices: [],
    vis: [],
    price: [],
    base: 0.00,
    total: 0.00,
    totalNet: 0.00,
    totalDiscount: 0.00,
    extras: [],
    extrasEdit: {},
    disabledButtons: false,
    discount: null
  }

  const [trayecto, setTrayecto] = useState<Stretch | CollaboratorStretch>()

  const [openDatePopup, setOpenDatePopup] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [visitas, setVisitas] = useState<Vis>(init)
  const [quantityExtras, setQuantityExtras] = useState<any>()
  const [, setDD] = useState<Object[]>([])
  const [dateClicked, setDateClicked] = useState<string>("")
  const [selectedHour, setSelectedHour] = useState<IHora>()
  const [totalSeats, setTotalSeats] = useState<number>(0)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [trayectoIdaVuelta, setTrayectoIdaVuelta] = useState<boolean>(false)
  const [channels, setChannels] = useState<any>()
  const [disabledCanal, setDisabledCanal] = useState<boolean>(false)
  const [adding, setAdding] = useState<boolean>(undefined)
  const [limiteCapacidad, setLimiteCapacidad] = useState<boolean>(false)
  const [minimumPassengerReach, setMinimumPassengerReach] = useState<boolean>(true)
  const [maximumPassengerReach, setMaximumPassengerReach] = useState<boolean>(false)
  const [horasDisponibles, setHorasDisponibles] = useState([])
  const [monedasGreenpay, setMonedasGreenpay] = useState<any>()
  const [prices, setPrices] = useState<any>()
  const [sentidoOrigen, setSentidoOrigen] = useState<boolean>(true) // Determina si el sentido es del origen del trayecto al destino o sale del destino al origen
  const [currencyCredomatic, setCurrencyCredomatic] = useState<string>()
  const [a, setA] = useState<any>()
  const [language, setLanguage] = useState<string>(idioma)
  const [languages, setLanguages] = useState<string[]>()
  const [loadingCouponCode, setLoadintCouponCode] = useState<boolean>(false)
  const [couponMessage, setCouponMessage] = useState<string>()
  const [couponMessageCode, setCouponMessageCode] = useState<number>()
  
  const [dataBuyer, setDataBuyer] = useState<DataBuyer>(null)
  const [supplied, setSupplied] = useState(null)
    
  let description = useRef('')
  let amount = 0
  let canalSi = false
  
  /*useScript(embebed ? 
    `https://dev.civitrip.com/iframeDisponibility.css` : null, {
    removeOnUnmount: true,
    // crossOrigin: 'anonymous',
    referrerPolicy: 'no-referrer'
  }
  )*/
  
  const querystring = window.location.search
  const params = new URLSearchParams(querystring)

  useEffect(() => {
    // @ts-ignore
    if (trayecto?.operator_id) {
      // @ts-ignore
      getProviderData(publicToken, trayecto.operator_id).then(value => {
        console.log('getProviderData - value: ', value)
        setSupplied(value)
      })
        .catch(reason => {
          console.log('getProviderData - reason: ', reason)
        })
    }
   
  }, [trayecto])
  
  // effect language
  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])
  
  // effect at
  useEffect(() => {
    const parsed = queryString.parse(window.location.search)
    if (parsed?.at) {
      Request.getAfiliate(publicToken, parsed.at)
        .then(value => {
          setA(value)
        })
        .catch(reason => {
          modalError(
            reason.code,
            'Contacte con el administrador de la página. Gracias y disculpe las molestias',
            () => {
              history.push(`/${publicToken}/error/${reason.code}?at=${parsed.at}`)
            }
          )
        })
    } else {
      setA(null)
    }
  }, [])

  // efecto para buyerUser
  useEffect(() => {
    
    if (params.has('u')) {
      BuyerRequest.getBuyerUser(publicToken, params.get('u')).then(result => {
        console.log('result: ', result)
        setDataBuyer(result.toSend?.buyerUser)
      }).catch((error) => console.log('error getBuyer - error: ', error))
      
    }
    
  }, [])
  

  // eftect uuid_dmn (para dominio a usar)
  useEffect(() => {

    try {
      if (params.has('uuid_dmn')) {
        let uuid_dmn = params.get('uuid_dmn')
        localStorage.setItem('uuid_dmn', uuid_dmn)
      } else {
        localStorage.setItem('uuid_dmn', 'dmn')
      }
    } catch (e) {
      if (publicToken) {
        history.push(`/${publicToken}/cookies`)
      }
    }
  }, [])

  // effect get channels
  useEffect(() => {
    if (!channels && a !== undefined) {
      getChannels(publicToken).then((res) => {
        if (res.msg === 'No TMT') {
          setChannels({msg: 'notmt. Code: 48'})
          if (res.currency) setCurrencyCredomatic(res.currency)
        } else if (res.msg === 'GREENPAY') {
          setMonedasGreenpay(res.monedasDisponibles)
          setChannels({msg: 'greenpay. Code: 49'})
        } else if (res.msg === 'No credenciales') {
          setChannels({msg: 'Servicio en mantenimiento. Code: 50'})
        } else {
          setChannels(res)
        }

      }).catch(e => {
        Sentry.captureException(new Error("StretchPage - getChannels"))
        setChannels({msg: 'error. Code: 51'})
      })
    }
  }, [a])

  // effect datos de servicio
  useEffect(() => {
    i18n.changeLanguage(idioma)
    if (trayecto || a === undefined) {
      return
    }

    if (props.isCollaborator) {
      getCollaboratorStretchData(publicToken, operator_id, stretch_id)
        .then((result) => {
          if (currencyCredomatic) {
            if (currencyCredomatic !== result.primaryMoney.alphabeticCode) {
              setDisabledCanal(true)
            }
          }
          procesaStretch(result.cs)
          setTrayecto(result.cs)
        }).catch(e => {
        const scope = new Sentry.Scope()
        scope.setTag("request", "getCollaboratorStretchData")
        Sentry.captureException(e, scope)
        console.log('e: ', e)
        history.push(`/${publicToken}/error/Este servicio está temporalmente no disponible`)
      })
      
      return
    }
    
    if (a) {
      getStretchA(publicToken, stretch_id, a.id).then(res => {
        procesaStretch(res)
        setTrayecto(res)
      })
      return
    }
    
    getStretch(publicToken, stretch_id).then((res: any) => {
      return new Promise((resolve, reject) => {
        res.text().then(body => {
          resolve(body.length ? JSON.parse(body) : null)
        }).catch(err => {
          reject(err)
        })
      })
    }).then((res: any) => {
      if (res) {
        procesaStretch(res)
      }
      setTrayecto(res)
    }).catch(error => {
      Sentry.captureException(new Error("Stretch - Este servicio con id parece que no existe " + error))
      modalError(`${t("noExistsStretch")}`)
    })
    /* getTrayectoByID(operationLine, stretch_id).then((res) => {
        console.log('res ',res)
            if(res.extras) {
                setQuantityExtras(new Array(res.extras.length).fill(0))
            }
            setTrayecto(res)
        })
        .catch(error => {
            console.log('error: ', error)
        }) 
    */
  }, [/*quantityExtras,*/ /*trayecto,*/ channels])


  // effect trayecto
  useEffect(() => {
    if (!trayecto) {
      return
    }

    const entries = Object.entries(trayecto?.dataweb?.array?.custom|| {})

    const languages = entries?.reduce((old, current, index) => {
      if (current[1] !== '') {
        old.push(current[0])
      }
      return old
    }, [])
      .sort()

    setLanguages(languages)
    
    description.current = trayecto.name
    let auxDD: Object[] = []
    if (trayecto.disabledDays) {
      trayecto.disabledDays.forEach((disabledDay) => {
        const date = new Date(disabledDay.year, disabledDay.month, disabledDay.day)
        const strjs = {
          title: 'No disponible',
          date: Moment(date).format("YYYY-MM-DD"),
          constraint: 'noDisponible',
          backgroundColor: '#ff9f89',
          display: 'background'
        }
        auxDD.push(strjs)
      })
      setDD(auxDD)
    }

    if (prices) {
      setDisabled(prices.length === 0)
      let auxVis: number[] = []
      
      const initVisitas = initVis({trayecto, prices, quantityExtras})
      setVisitas(initVisitas)
      
      setMinimumPassengerReach(getMininimumPassengerREach({prices}))
      setTotalSeats(0)
    } else {
      setDisabled(true)
    }

    if (channels && !channels.hasOwnProperty('msg')) { // Si no tiene msg es porque tiene canales de tmt
      channels.forEach(c => {
        if (c.currencies === trayecto.primaryMoney.alphabeticCode) {
          canalSi = true
        }
      })
      setDisabledCanal(!canalSi)
    } else if (channels && channels.msg && channels.msg.includes('greenpay') && trayecto) {
      let moneda = trayecto.primaryMoney.alphabeticCode
      if (monedasGreenpay.includes(moneda)) {
        canalSi = true
      }
      setDisabledCanal(!canalSi)
    } else if (currencyCredomatic && trayecto) {
      if (currencyCredomatic !== trayecto.primaryMoney.alphabeticCode) {
        setDisabledCanal(true)
      }
    }

  }, [trayecto])

  // effect para poner las horas
  useEffect(() => {
    if (trayecto) {
      const horas = trayecto.horasIda
      if (horas && horas.length !== 0 && !selectedHour) {
        setHorasDisponibles(horas)
        // setSelectedHour(horas[0])
      }
    }
  }, [])

  useEffect(() => {
    if (trayecto) {
      const horas = trayecto.horasIda
      if (horas && horas.length !== 0 && !selectedHour) {
      }
    }
  }, [horasDisponibles])

  // effect ida-vuelta
  useEffect(() => {
    if (!trayectoIdaVuelta) { // El trayecto es solo ida
      if (trayecto && trayecto.prices) {
        setPrices(trayecto.prices)
      } else if (trayecto && !trayecto.prices && trayecto.vueltaPrices) {
        setPrices(trayecto.vueltaPrices)
      }
    } else { // el trayecto es ida y vuelta
      if (trayecto && trayecto.vueltaPrices) {
        setPrices(trayecto.vueltaPrices)
      } else if (trayecto && !trayecto.vueltaPrices && trayecto.prices) {
        setPrices(trayecto.prices)
      }
    }
  }, [trayectoIdaVuelta, trayecto])


  const procesaStretch = (res) => {
    if (res.extras) {
      setQuantityExtras(new Array(res.extras.length).fill(0))
    }
    if (res.prices) {
      res.prices.sort(function (a, b) {
        if (a.passengerCategory.order > b.passengerCategory.order) {
          return 1
        }
        if (a.passengerCategory.order < b.passengerCategory.order) {
          return -1
        }
        // a must be equal to b
        return 0
      })
      setPrices(res.prices)
    }
    if (currencyCredomatic) {
      if (currencyCredomatic !== res.primaryMoney.alphabeticCode) {
        setDisabledCanal(true)
      }
    }
  }

  const clickDateHandler = (arg: {
    date: Date
    dateStr: string
    allDay: boolean
    dayEl: HTMLElement
    jsEvent: MouseEvent
    view: ViewApi
  }) => {

    if (!trayecto) {
      return
    }

    // Solamente el día clicado en cada momento será el día seleccionado con fondo azul
    const days = document.querySelectorAll(".color-selected")
    days.forEach(function (day) {
      day.classList.remove("color-selected")
    })

    arg.dayEl.classList.add("color-selected")
    const date = arg.date
    let pertenece: boolean = false

    const dataMaxBeforeReserve: IMaxBeforeReserve = {
      date,
      isTramoHora: trayecto.tramoHora,
      valueMaxBeforeReserve: trayecto.valueMaxBeforeReserve,
      typeMaxBeforeReserve: trayecto.typeMaxBeforeReserve
    }
    let resultHorasIdaAvailable: IHora[] = horasIdaAvailableBefore(trayecto.horasIda, dataMaxBeforeReserve)

    let _selectedHour = selectedHour
    if (trayecto.disabledDays) {
      // miro si el día clicado está en deshabilitados
      const position = trayecto.disabledDays.findIndex(disabledDay =>
        disabledDay.day === date.getDate() && disabledDay.month === date.getMonth() && disabledDay.year === date.getFullYear()
      )

      if (position === -1) { // no está en disabledDays, el día está habilitado
        if (trayecto.tramoHora && trayecto.horasIda && resultHorasIdaAvailable.length > 0) {
          setHorasDisponibles(resultHorasIdaAvailable)
          if (selectedHour) {
            const finded = resultHorasIdaAvailable.find(available => selectedHour.hours === available.hours && selectedHour.minutes === available.minutes)
            if (!finded) {
              _selectedHour = resultHorasIdaAvailable[0]
            }
          }
        }
        if (!selectedHour && trayecto.horasIda && resultHorasIdaAvailable.length > 0) {
          _selectedHour = resultHorasIdaAvailable[0]
        }
      } else { // el día está en disabledDays. puede ocurrir varias condiciones
        // busco el día deshabilitado
        const dayDisabled = trayecto.disabledDays[position]

        // tramoHora: si hours.length === 0 all dia deshabilitado, si hours.length >0 tiene horas deshabilitadas
        if (!trayecto.tramoHora) {// no es tramoHora, el día está deshabilitado
          pertenece = true
        } else {
          if (dayDisabled.hours.length === 0) { // todas las horas deshabilitadas
            setHorasDisponibles([])
            pertenece = true
          } else {
            const horasIdaReduced = horasIdaAvailable(resultHorasIdaAvailable || [], dayDisabled)
            // setHorasDisponibles(horasIdaReduced)
            if (horasIdaReduced.length === 0) {
              pertenece = true
            } else {
              let incluido = []
              if (selectedHour) {
                incluido = horasIdaReduced.filter(hora => hora.id === selectedHour.id)
              }
              if (!selectedHour || incluido.length === 0) {
                _selectedHour = horasIdaReduced[0]
              }
            }
            resultHorasIdaAvailable = horasIdaReduced
          }
        }
      }
    } else {
      if (trayecto.tramoHora && trayecto.horasIda && resultHorasIdaAvailable.length > 0) {
        setHorasDisponibles(resultHorasIdaAvailable)
        if (!selectedHour) {
          _selectedHour = resultHorasIdaAvailable[0]
        }
      }
    }

    const {typeMaxToReserve, valueMaxToReserve, dateMaxToReserve, typeMaxBeforeReserve, valueMaxBeforeReserve} = trayecto

    // Miro si tiene fecha o dias máximos para reservar
    const maxToReserveResult = DisabledDay.maxToReserve(
      date, typeMaxToReserve, valueMaxToReserve, dateMaxToReserve
    )


    // Miro si tiene dateBeforeMax

    let hoursMinutes = _selectedHour ?? resultHorasIdaAvailable[0]
    const finded = resultHorasIdaAvailable.find(available => hoursMinutes.hours === available.hours && hoursMinutes.minutes === available.minutes)
    if (!finded) {
      hoursMinutes = resultHorasIdaAvailable[0]
    } else {
      hoursMinutes = finded
    }

    const maxBeforeReserveResult = DisabledDay.maxBeforeReserve(
      date, typeMaxBeforeReserve, valueMaxBeforeReserve, trayecto.tramoHora, hoursMinutes
    )


    let todaysDate = new Date()
    todaysDate.setHours(0, 0, 0, 0)

    let dateParsed = new Date(date)
    const beforeToday = dateParsed < todaysDate

    if (!pertenece && !beforeToday && !maxToReserveResult && !maxBeforeReserveResult) {
      //"2020-08-04T14:58:01.415Z"
      setHorasDisponibles(resultHorasIdaAvailable)
      setSelectedHour(_selectedHour)
      setDateClicked(Moment(date).format())
    } else {
      setOpenDatePopup(true)
    }
  }

  const closeClickDateHandler = () => {
    setOpenDatePopup(false)
    setDateClicked('')
  }

  const addExtras = (event: any) => {
    const index = event.currentTarget.value
    if (trayecto && index) {
      const {auxVis, limite} = addExtraGlobal(visitas, trayecto, index)
      if (auxVis !== null) setVisitas(auxVis)
    }
  }

  const quitarExtras = (event: any) => {
    const index = event.currentTarget.value
    if (visitas.extrasEdit.quantityExtras[index] === 0) {return}
    if (trayecto && index) {
      const {auxVis, limite} = quitarExtraGlobal(visitas, trayecto, index)
      if (auxVis !== null) setVisitas(auxVis)
    }
  }

  const addVisitantePrices = (event: any) => {
    const index = event.currentTarget.value
    if (trayecto && index) {
      const {auxVis, limite} = addVisitanteGlobal(visitas, trayecto, index, prices)
      prices.forEach(price => {
        if (price.passengerCategory.minToReserve && price.price > 0) {
          const name = price.passengerCategory.name
          const index = auxVis.names.indexOf(name)
          const nReserve = auxVis.vis[index]
          if (nReserve >= price.passengerCategory.minToReserve) {
            setMinimumPassengerReach(true)
          } else {
            setMinimumPassengerReach(false)
          }
        }
      })
      setLimiteCapacidad(limite)
      if (auxVis !== null) setVisitas(auxVis)
      let auxTot = totalSeats
      auxTot++
      setTotalSeats(auxTot)
    }
  }

  const quitarVisitantePrices = (event: any) => {
    const index = event.currentTarget.value
    if (visitas.vis[index] === 0) {
      return
    }
    if (trayecto && index) {
      const auxVis = quitarVisitanteGlobal(visitas, trayecto, index, prices)
      prices.forEach(price => {
        if (price.passengerCategory.minToReserve && price.price > 0) {
          const name = price.passengerCategory.name
          const index = auxVis.names.indexOf(name)
          const nReserve = auxVis.vis[index]
          if (nReserve >= price.passengerCategory.minToReserve) {
            setMinimumPassengerReach(true)
          } else {
            setMinimumPassengerReach(false)
          }
        }
      })
      if (auxVis !== null) setVisitas(auxVis)
      setLimiteCapacidad(false)
      let auxTot = totalSeats - 1
      setTotalSeats(auxTot)
    }
  }

  const handleChangeOpcionVuelta = (event: any) => {
    setTrayectoIdaVuelta(!trayectoIdaVuelta)
  }

  const handleSentidoTrayecto = () => {
    setSentidoOrigen(!sentidoOrigen)
  }

  const horaChangeHandler = (event: any) => {

    const id = event.currentTarget.value
    if (id !== undefined && trayecto) {
      let hora = trayecto.horasIda.find(hora => hora.id === +id)
      if (hora) {
        // compruebo que hora y día seleccionados no haya pasado
        const now = new Date()
        const dateSelected = new Date(dateClicked)
        dateSelected.setHours(hora.hours, hora.minutes, 0, 0)

        if (now > dateSelected) {
          return setOpenDatePopup(true)
        }
        setSelectedHour(hora)
      }

    }
    /*const index = event.currentTarget.value
    if (index !== undefined && trayecto) {
        const hora = trayecto.horasIda[index]
        setSelectedHour(hora)
    } */
  }

  const addCart = async () => {
    if (!dateClicked) {
      setOpenDatePopup(true)
    } else {
      setAdding(true)
      amount = (+visitas.total.toFixed(2)) * 100
      if (trayecto/* && bu*/) {
        let tokenTicket
        try {
          tokenTicket = localStorage.getItem('tokenTicket')
          if (!tokenTicket) {
            tokenTicket = generateTokenticket(20)
            localStorage.setItem('tokenTicket', tokenTicket)
          }
        } catch (e) {
          history.push(`/${publicToken}/cookies`)
        }

        // elimino de la venta las categoria de pasajero con 0 pasajeros
        // @ts-ignore
        const visitasSanited: Vis = visitas // visSanited(visitas)
        
        const ticket: any = await mountPayloadStretch(
          {
            stretch: trayecto,
            selectedDate: dateClicked,
            selectedHour,
            visitas,
            lengthsName: props.isCollaborator? 'collaboratorStretch' : 'stretch',
            publicToken,
            trayectoIdaVuelta,
            sentidoOrigen,
            prices,
            channels,
            afiliate: a,
            dataBuyer
          }
        )

        const additional = {
          stretchName: trayecto.name,
          stretchDescription: trayecto.description,
          tokenticket: tokenTicket,
          description: description
        }
        
        if (props.isCollaborator) {
          ticket.operator_id = (trayecto as CollaboratorStretch).operator_id
          ticket.type =  TypeTicket.CollaboratorStretch
          ticket.operatorName = (trayecto as CollaboratorStretch).operatorName
        } else {
          ticket.type = TypeTicket.Stretch
        }
        
        ticket.additional = additional
        ticket.visitas = visitasSanited
        ticket.prices = prices
        ticket.tax = trayecto.tax
        ticket.transferService = trayecto.transferService
        
        if (embebed) {
          ticket.type = TypeTicket.CollaboratorStretch
        }

        let uuid
        try {
          uuid = localStorage.getItem('tokenTicket')
        } catch (e) {
          history.push(`/${publicToken}/cookies`)
        }
        
        const callbackThen = (res) => {
          setAdding(false)
          let message: string = ""
          let info = false
          console.log('res: ', res)
          switch (res.code || res) {
            case 200:
              if (!uuid) {
                try {
                  localStorage.setItem('tokenTicket', res.payload.token)
                } catch (e) {
                  history.push(`/${publicToken}/cookies`)
                }
              }

              const queriesString = []
              if (params.has('a')) {
                queriesString.push({key: 'a', value: a.publicToken})
              }
              if (params.has('u')) {
                queriesString.push({key: 'u', value: params.get('u')})
              }

              const queryStr = generateQueryString(queriesString)
              console.log('queryStr: ', queryStr)
              
              if (embebed) {
                return history.push(`/civitrip/${publicToken}/cart${queryStr}`)
              }
              
              history.push(`/${publicToken}/cart${queryStr}`)
              break
            case 400:
              message = t("tokenNoExists") // El token no existe.
              break
            case 404:
              message = t("stretchInCart") //'Ya tiene agregada esa experiencia al carrito, si quiere modificarla tendrá que eliminarla primero del carrito.'
              break
            case 410:
              message = t("errorCreateTicket") //"Error al generar el ticket."
              break
            case 412:
              message = t("obtainError") //"Hemos obtenido un error."
              break
            case 413:
              info = true
              const {available, quantityToReserve} = res
              let msgAvailable = ''
              if (available && quantityToReserve) {
                msgAvailable = ` ${t('forReserve')} ${quantityToReserve}, ${t('thereIs')} ${available} ${available > 1 ? t('availables') : t('available')}`
              }
              message = `${ticket.tramoHora ? t("noDisponibility") : t('noDisponibilityDay')}${msgAvailable} ${t("thenDisponibility")}`
              break
            case 414:
              info = true
              message = t("serviceNotAvailable") //"El servicio que quiere reservar no está disponible."
              break
            case 415:
              info = true
              message = t("dateDisabled") //"El servicio está deshabilitado para esa fecha."
              break
            case 416:
              info = true
              message = t("hourDisabled") //"El servicio está deshabilitado para esa hora."
              break
            
            case 433: // el carrito está cobrado y por algún motivo no se ha notificado a esta pantalla
              console.log(`tokenTicket: ${tokenTicket} ya está pagado`)
              // elimino carro de localStorage
              localStorage.removeItem('tokenTicket')
              
              console.log('creando tokenTicket nuevo')
              // creo tokenTicket nuevo y pongo en localStorage
              const newTokenTicket = generateTokenticket(20)
              localStorage.setItem('tokenTicket', newTokenTicket)
              
              console.log('tokenTicket nuevo: ', newTokenTicket)
              console.log('enviando ticket a carrito')
              // envío de nuevo petición de addCart
              console.log('ticket: ', ticket)
              setAdding(true)
              addTicketToCart(newTokenTicket)
              break
            
            case 500:
              message = t("serverError") //"Error interno del servidor."
              break
            default:
              message = t("Sorry, we got an unexpected error.") //"Lo siento, hemos obtenido un error inesperado."
              break
          }
          if (message !== "") {
            if (info) {
              modalInfo(message, t)
            } else {
              modalError(message)
            }
          }
        }
        
        const callbackCatch = e => {
          setAdding(false)
          console.log('e: ', e)
          Sentry.captureException(new Error(`Stretch - Añadir: ${e.message}`))
          modalError(t("errorAddCart"))
        }
        
        const addTicketToCart = (tokenTiket?: string) => {
          if (props.isCollaborator) {
            // pongo publicToken de Civitrip OJO cuando se haga merge con rama main
            const pt = 'opDXLdbBtYTCOdvtOamctbkBsHcssCehriFELgFFFYHTCCNRcAsXbdYUkBMdDrLuZQxkwD'
            if (pt !== publicToken) {
              const error = new Error()
              callbackCatch(error)
            }
            
            if (tokenTiket) {
              ticket.additional.tokenticket = tokenTiket
            }
            
            addCollaboratorStretchToCart(ticket, pt)
              .then(callbackThen)
              .catch(callbackCatch)
          } else {
            addStretchToCart(ticket, publicToken).then(callbackThen).catch(callbackCatch)
          }
        }
        addTicketToCart()
      }
    }
  }

  const applyDiscount = (discount: IDiscount) => {
    const auxVis = addDiscount({vis: visitas, discount})
    setVisitas(auxVis)
  }
  
  const handleApplyDiscount = (value) => {
    setLoadintCouponCode(true)
    applyCoupon({stretch_id: trayecto.id, couponCode: value, token: publicToken})
      .then(response => {
        if (response.result === 'ok') {
          // console.log('response: ', response)
          const responseDiscountCode = response.discountCode
          const message = `${responseDiscountCode.code} ${t('appliedSuccessfully')}`
          setCouponMessage(message)
          setCouponMessageCode(response.code)
          const discount: IDiscount = {
            discountCode: responseDiscountCode.code,
            typeDiscount: responseDiscountCode.typeDiscount,
            value: responseDiscountCode.value
          }
          applyDiscount(discount)
        } else {
          const message = response.code === 404 ? T('codeNotFound') :response.message
          setCouponMessage(message)
          setCouponMessageCode(response.code)
        }
      })
      .catch(reason => {

      })
      .finally(() => setLoadintCouponCode(false))
  }
  
  const handleResetDiscount = (() => {
    setCouponMessage(null)
    const tempVisitas = resetDiscount({vis: visitas})
    setVisitas(tempVisitas)
  })
  
  let disableAddCart = true
  if (trayecto) {
    disableAddCart = !visOK(visitas) || dateClicked === ''
  }

  const images = []
  if (trayecto && trayecto.dataweb) {
    for (let index in trayecto.dataweb) {
      if (index.startsWith('image') && trayecto.dataweb[index] !== '') {
        const temp = {
          original: trayecto.dataweb[index].replace('http://', 'https://'),
          thumbnail: trayecto.dataweb[index].replace('http://', 'https://')
        }
        images.push(temp)
      }
    }
  }

  if (images.length === 0) {
    images.push(
      {
        original: "https://res.cloudinary.com/marketingpyme/image/upload/w_540,h_300,c_fill/v1639043362/civitrip/plugin/sinImagen.jpg",
        thumbnail: "https://res.cloudinary.com/marketingpyme/image/upload/w_540,h_300,c_fill/v1639043362/civitrip/plugin/sinImagen.jpg"
      })
  }

  if (!trayecto) {
    return (
      <div
        className="page-wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Spinner color="primary" style={{width: 100, height: 100}}/>
      </div>
    )
  }


  const _total = visitas.total - visitas.totalDiscount
  const totalString = (_total).toFixed(2) + ` ${trayecto.primaryMoney.alphabeticCode}`
  
  const disableButtonAddCart = disableAddCart || disabled || disabledCanal || !minimumPassengerReach
  /*if (embebed) {
    
    priceLines = getPriceLines({trayecto, prices, visitas})
    extraLines = getExtraLines({trayecto, visitas})
    return (
      <Disponibility
        stretch={trayecto}
        language={idioma}
        dateClicked={dateClicked}
        selectedHour={selectedHour}
        clickDateHandler={clickDateHandler}
        disabledDays={trayecto.disabledDays}
        idaVuelta={trayecto.vuelta}
        idaVueltaSelected={trayectoIdaVuelta}
        
        priceLines={priceLines}
        extraLines={extraLines}
        
        origin={trayecto.origin}
        destination={trayecto.destination}
        
        total={totalString}
        
        totalDiscount={visitas.totalDiscount}
        codeDiscount={''}
        disableAddButton={disableButtonAddCart}
        
        onAdd={addVisitantePrices}
        onRemove={quitarVisitantePrices}
        onAddExtra={addExtras}
        onRemoveExtra={quitarExtras}
        onRoundTripHandle={handleChangeOpcionVuelta}
        onApplyCoupon={handleApplyDiscount}
        onResetCoupon={handleResetDiscount}
        onAddCart={addCart}
      />
    )
  }*/
  
  const queriesString = []
  if (a) {
    queriesString.push({key: 'a', value: a.publicToken})
  }
  if (params.has('u')) {
    queriesString.push({key: 'u', value: params.get('u')})
  }
  
  const handleOnApplyDiscountCode = (value) => {
    console.log('value: ', value)
    setLoadintCouponCode(true)
    applyCoupon({stretch_id: 1, couponCode: value, token: publicToken})
      .then(response => {
        if (response.result === 'ok') {
          console.log('response: ', response)
          const responseDiscountCode = response.discountCode
          const message = `${responseDiscountCode.code} ${t('appliedSuccessfully')}`
          setCouponMessage(message)
          setCouponMessageCode(response.code)
          const discount: IDiscount = {
            discountCode: responseDiscountCode.code,
            typeDiscount: responseDiscountCode.typeDiscount,
            value: responseDiscountCode.value
          }
          handleApplyDiscount(discount)
        } else {
          const message = response.code === 404 ? T('codeNotFound') : response.message
          setCouponMessage(message)
          setCouponMessageCode(response.code)
        }
      })
      .catch(reason => {

      })
      .finally(() => setLoadintCouponCode(false))
  }
  
  const handleResetDiscountCode = (() => {
    setCouponMessage(null)
    const tempVisitas = resetDiscount({vis: visitas})
    setVisitas(tempVisitas)
  })
  
  const queryStr = generateQueryString(queriesString)
  
 /* return (
    <ExperienceDetail
      stretch={trayecto}
      publicToken={publicToken}
      images={images}
      stretchPrices={prices}
      total={_total.toFixed(2)}
      onLanguageChange={setLanguage}
      onApplyDiscount={handleOnApplyDiscountCode}
    />
  )*/
  
  // console.log('dataBuyer: ', dataBuyer)
  
  return (
    <div className="page-wrapper animated fadeIn">
      <HeaderView publicToken={publicToken} pathname={`${embebed? '/civitrip' : ''}/${publicToken}/cart${queryStr}`}/>
      <DataBuyerHeader
        dataBuyer={dataBuyer}
      />
      <AgencyHeaderView dataBuyer={dataBuyer} onClickBuyerAgency={(authToken) => {
        const urlParams = new URLSearchParams(window.location.search)
        urlParams.set('u', authToken)
        window.location.search = urlParams.toString()
      }}/>
      
      <section className="page-header tour-two tour-list destinations-details">
        <div className="container">
          <div className="row">

            {
              ((!trayecto && trayecto !== null) || !channels) &&
              <div style={{top: '50%', left: '50%,', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Spinner color="primary" style={{width: 100, height: 100}}></Spinner>
              </div>

            }

            {
              trayecto === null &&
              <BodyError message={t("noExistsStretch")} listParagraph={[t("contactAdmin"), t("thanksSorry")]}/>
            }

            {
              trayecto && (trayecto.disableWeb || trayecto.disabled_at || trayecto.operationLine.disabled_at) &&
              <BodyError message={t("serviceNotAvailable")} listParagraph={[t("thanksSorry")]}/>
            }

            {
              channels && channels.hasOwnProperty('msg') && channels.msg.includes('Code: 5') &&
              <BodyError message={channels.msg ? channels.msg : 'error'}
                         listParagraph={[t("requestChannelsErrormsg"), t("thanksSorry")]}/>
            }

            {
              trayecto && !trayecto.disableWeb && !trayecto.disabled_at && !trayecto.operationLine.disabled_at && channels && ((channels.hasOwnProperty('msg') && !channels.msg.includes('Code: 5')) || !channels.hasOwnProperty('msg')) &&
              <>
                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8">
                  {
                    disabledCanal && channels.hasOwnProperty('msg') && !channels.msg.includes('greenpay') && !currencyCredomatic &&
                    <div style={{backgroundColor: 'red', color: 'white'}}>
                      {t("noMoneyTMT")}
                    </div>
                  }
                  {
                    disabledCanal && channels.hasOwnProperty('msg') && channels.msg.includes('greenpay') &&
                    <div style={{backgroundColor: 'red', color: 'white'}}>
                      {t("noMoneyGreenpay")}
                    </div>
                  }

                  {
                    disabledCanal && currencyCredomatic && currencyCredomatic !== trayecto.primaryMoney.alphabeticCode &&
                    <div style={{backgroundColor: 'red', color: 'white'}}>
                      {t("noMoneyCredomatic")}
                    </div>
                  }

                  <div className="destinations-details__content">
                    <h3 className="destinations-details__title">{trayecto.name}</h3>
                    <Carousel autoPlay infiniteLoop showStatus={false}>
                      {
                        images.filter(im => im.original !== '').map((image, index) => {
                          return (
                            <div key={image.original}>
                              <img key={index}
                                   src={image.original.replace("w_250,h_200,c_fill", "c_fill").replace("w_450,h_350", "")}
                                   alt=''/>
                            </div>
                          )
                        })
                      }
                    </Carousel>

                    <LanguageButtons
                      languages={languages}
                      languageSelected={language}
                      onClick={(lang) => {
                        localStorage.setItem('idioma', lang)
                        setLanguage(lang)
                      }}
                    />

                    <InfoWeb
                      trayecto={trayecto}
                      orden={1}
                      publicToken={publicToken}
                      language={language}
                      /*provider={{
                        tin: ''
                      }}*/
                    />

                  </div>
                </div>

                <div className={"col-xs-12 col-sm-12 col-md-5 col-lg-4"}>
                  <div className="tour-sidebar">
                    <div className="tour-sidebar__featured">
                      {/*<CtaView t={t}/>*/}
                      <h3>{trayecto.name}</h3>
                      <hr/>
                      <div className="container">
                        <div className={'fechas'}>
                          <div className="col-sm-12 col-md-6">
                            <CalendarAvailable
                              language={idioma}
                              dateSelected={dateClicked}
                              stretch={trayecto}
                              selectedHourMinutes={selectedHour}
                              clickDateHandler={clickDateHandler}
                            />

                            {
                              dateClicked !== "" &&
                              <p className="lead">
                                <b>{t("dateSelected")}:</b> {Moment(dateClicked).format("DD/MM/YYYY")}
                              </p>
                            }
                            {
                              // dateClicked && trayecto.horasIda && trayecto.horasIda.length !== 0 &&
                              selectedHour && dateClicked && trayecto.tramoHora && horasDisponibles && horasDisponibles.length > 0 &&
                              <div className={`horas`}>
                                <h3>{t("departureTime")}</h3>
                                <select value={selectedHour.id} className="custom-select" id="hourSelect"
                                        onChange={horaChangeHandler}>
                                  {
                                    horasDisponibles.map((hora) => {
                                      const horaString = ((hora.hours.toString().length === 1) ? "0" : "") + hora.hours.toString() + hora.minutes.toString()
                                      const horaSalida = Moment(horaString, "HHmm").format('HH:mm')
                                      return (
                                        <option value={hora.id} key={hora.id}>
                                          {horaSalida}
                                        </option>
                                      )
                                    })
                                  }
                                </select>
                              </div>
                            }
                          </div>
                          <div className="col-sm-12">
                            <CodeDiscountView
                              loading={loadingCouponCode}
                              code={couponMessageCode}
                              message={couponMessage}
                              onApply={handleOnApplyDiscountCode}
                              onReset={handleResetDiscountCode}
                            />
                            <PricesView
                              prices={prices}
                              money={trayecto.primaryMoney.alphabeticCode}
                              tax={trayecto.tax}
                              visitas={visitas}
                              addVisitantePrices={addVisitantePrices}
                              quitarVisitantePrices={quitarVisitantePrices}
                              limiteCapacidad={limiteCapacidad}
                              publicToken={publicToken}
                              minimumPassengerReach={minimumPassengerReach}
                            />

                            {
                              trayecto.extras && trayecto.extras.length !== 0 &&
                              <Extras
                                money={trayecto.primaryMoney.alphabeticCode}
                                visitas={visitas}
                                trayecto={trayecto}
                                addExtras={addExtras}
                                quitarExtras={quitarExtras}
                              />
                            }

                            {
                              trayecto.vuelta &&
                              <div className="opciones">
                                <VueltaViceversaView
                                  trayecto={trayecto}
                                  sentidoOrigen={sentidoOrigen}
                                  idaVuelta={trayecto.vuelta && trayecto.prices?.length > 0 && trayecto.vueltaPrices?.length > 0}
                                  handleChangeOpcionVuelta={() => {}}
                                  handleSentido={handleSentidoTrayecto}
                                />
                                <br/>
                              </div>
                            }
                            {
                              trayecto.hoponHopoff &&
                              <div className="opciones">
                                <div>
                                  <p className="outline-primary">HoponHopff</p>
                                </div>
                              </div>
                            }
                          </div>
                        </div>

                        <div className="book-form-totals">
                          {visitas.discount && <p className='totalAlign'>
                            <b>{T('subtotal')}: </b> {visitas.total.toFixed(2)} {trayecto.primaryMoney.alphabeticCode}
                          </p>}
                          {visitas.discount && <p className='totalAlign'>
                            <b>{T('discount')}: </b> {-visitas.totalDiscount.toFixed(2)} {trayecto.primaryMoney.alphabeticCode}
                          </p>}
                          <p className='totalAlign'>
                            <b>{T('total')}: </b> {_total.toFixed(2)} {trayecto.primaryMoney.alphabeticCode}
                          </p>
                        </div>
                      </div>

                      <DialogNoDate openDatePopup={openDatePopup} closeClickDateHandler={closeClickDateHandler} t={t}/>
                      {
                        disabled &&
                        <div>
                          {t("experienceNotAvailablemsg")}
                        </div>
                      }
                      {
                        !adding &&
                        <button style={{margin: '20px !important', marginBottom: '35px !important'}} type="button"
                                disabled={disableAddCart || disabled || disabledCanal || !minimumPassengerReach}
                                className="btn-huge btn-wide btn-blue test-add-to-cart-action-enabled"
                                onClick={addCart}>
                          {t('addCart')}
                        </button>
                      }
                      {supplied && <div style={{paddingLeft: '50px', marginTop: '5px', marginBottom: '5px'}}>
                        <p style={{marginTop: '5px', marginBottom: '5px'}}>{'proporcionado por'} {supplied.tradename}</p>
                        <p style={{marginTop: '5px', marginBottom: '5px'}}><span>{supplied.businessName}</span> <span>{supplied.tin}</span></p>
                        <p style={{marginTop: '5px', marginBottom: '5px'}}><span>{supplied.address}</span></p>
                        <p style={{marginTop: '5px', marginBottom: '5px'}}> <span>{supplied.zip} {supplied.city}</span></p>
                      </div>}

                      {
                        adding &&
                        <button type="button" disabled={disableAddCart || disabled || disabledCanal}
                                className="btn-huge btn-wide btn-blue test-add-to-cart-action-enabled">
                          <Spinner/>
                        </button>
                      }
                      
                      <InfoWeb trayecto={trayecto} orden={2} publicToken={publicToken}/>
                      
                    </div>
                  </div>
                </div>
              </>
            }
          </div>
        </div>
      </section>
      <FooterView/>
    </div>
  )
}

export const handleCartItems = (publicToken) => {
  const uuid = localStorage.getItem('tokenTicket')
  if (uuid) {
    getCart(uuid, publicToken).then(res => {
      if (res.code === 200) {
        console.log('enviando mensaje carrito')
        const toSend = {
          type: 'cartItems',
          value: getNumberItemsCart(res)
        }
        window.parent.postMessage(JSON.stringify(toSend), '*')
      }
    })
  }
}